<div class="box modal alert-wrapper" [class.light-box]="isLightTheme">
  @if (messageType !== 7) {
    <h1>{{ 'ALERT.INFO' | translate }}</h1>
  }

  <ng-container>
    <div class="helper">
      <div class="text-wrapper">
        <label class="bigFontSize">
          <br />
          <!--          <span class="successMessage bigFontSize">{{successMessage}}</span>-->
          @if (messageType === 1) {
            <span class="successMessage">{{ 'ALERT.CONGRAT_REGISTRATION_BONUS' | translate }}</span>
          }
          @if (messageType === 2) {
            <span class="successMessage">{{ 'ALERT.ERROR_NO_BONUS_WALLET' | translate }}</span>
          }
          @if (messageType === 3) {
            <span class="successMessage">{{ 'ALERT.CONGRAT_DEPOSIT_BONUS' | translate }}</span>
          }
          @if (messageType === 4) {
            <span class="successMessage">{{ 'ALERT.CONGRAT_KYC_BONUS' | translate }}</span>
          }
          @if (messageType === 5) {
            <span class="successMessage"
              >{{ 'ALERT.ERROR_LIMIT2_IS_RICHED_WITHDRAWALS' | translate }}
            </span>
          }
          @if (messageType === 5) {
            <a href="mailto:support@intebix.com">support&#64;intebix.com</a>
          }
          @if (messageType === 7) {
            <span class="successMessage">{{ 'MARKETS.LOADING' | translate }}...</span>
            <div class="spinner-wrapper">
              <mat-progress-spinner [mode]="'indeterminate'" [diameter]="15"></mat-progress-spinner>
            </div>
          }
          @if (messageType === 8) {
            <span class="successMessage bigFontSize red">{{ successMessage }}</span>
          }
          <br /> </label
        ><br />
      </div>
      @if (messageType !== 7) {
        <div
          class="btn-wrapper"
          [class.centered]="messageType === 2 || messageType === 5"
          [class.spaced]="
            messageType === 1 || messageType === 3 || messageType === 4 || messageType === 8
          "
        >
          <button
            type="button"
            value="OK"
            (click)="redirectClose()"
            [class.centered]="!isVisibleNavigateToWalletButton"
          >
            OK
          </button>
          @if (isVisibleNavigateToWalletButton) {
            <button type="button" value="Wallet" (click)="navigateToWallet()">
              {{ 'ALERT.GOTOWALLET' | translate }}
            </button>
          }
        </div>
      }
    </div>
  </ng-container>
</div>
